function lockTabindex(el) {
  if (el.getAttribute('tabindex') === '0') {
    el.setAttribute('data-orig-tabindex', '0');
    el.setAttribute('tabindex', '-1');
  }
}

function unlockTabindex(el) {
  if (el.hasAttribute('data-orig-tabindex')) {
    el.setAttribute('tabindex', '0');
    el.removeAttribute('data-orig-tabindex');
  }
}

function syncAriaHiddenTabindex(root) {
  var targets = root.getAttribute && root.getAttribute('aria-hidden') === 'true' ? [root] : [];
  root.querySelectorAll && root.querySelectorAll('[aria-hidden="true"]').forEach(function (el) {
    targets.push(el);
  });
  targets.forEach(function (hidden) {
    hidden.querySelectorAll('[tabindex="0"]').forEach(lockTabindex);
  });
}

function observeViewerAccessibility(container) {
  var pending = false;

  new MutationObserver(function (mutations) {
    var hasChildListChange = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        var target = mutation.target;
        if (target.getAttribute('aria-hidden') === 'true') {
          target.querySelectorAll('[tabindex="0"]').forEach(lockTabindex);
        } else {
          target.querySelectorAll('[data-orig-tabindex]').forEach(unlockTabindex);
        }
      } else if (mutation.type === 'childList') {
        hasChildListChange = true;
      }
    });

    if (hasChildListChange && !pending) {
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        syncAriaHiddenTabindex(container);
      });
    }
  }).observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
}

function initVideoTabViewers() {
  document.querySelectorAll(".video-tabs__viewer[data-video-id]").forEach(function (el, idx) {
    if (el.dataset.initialized === "true") return;

    var videoId = el.getAttribute("data-video-id");
    if (!videoId) return;

    var containerId = "s7viewer-" + idx;
    el.id = containerId;
    el.dataset.initialized = "true";

    var viewer = new s7viewers.VideoViewer({
      containerId: containerId,
      params: {
        asset: videoId,
        config: "bhsf/Video",
        serverurl: "https://s7d9.scene7.com/is/image/",
        contenturl: "https://s7d9.scene7.com/is/content/",
        videoserverurl: "https://s7d9.scene7.com/is/content",
      }
    });

    viewer.init();
    el.viewer = viewer;
    observeViewerAccessibility(el);
  });
}

const stopVideoPlayback = () => {
  document.querySelectorAll(".js-tab-panel").forEach((panel) => {
      const videoEl = panel.querySelector(".video-tabs__viewer[data-video-id]");
      if (videoEl && videoEl.viewer && videoEl.viewer.videoplayer) {
        videoEl.viewer.videoplayer.pause();
      }
  });
}

const tabLinks = document.querySelectorAll('.video-tabs__tabs-list-link');
tabLinks.forEach(link => {
  link.addEventListener("click", function () {
    stopVideoPlayback();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".video-tabs__viewer[data-video-id]")) {
    Scene7Loader.load(initVideoTabViewers);
  }
});

// Fullscreen handling for inline-video-container
let lastFullscreenContainer = null;
let lastOriginalPosition = null;

document.addEventListener('fullscreenchange', function () {
  // Find the fullscreen element
  const fsElement = document.fullscreenElement;
  // Check if the fullscreen element is inside a .video-tabs__viewer
  const videoViewer = fsElement ? fsElement.closest('.video-tabs__viewer') : null;
  if (fsElement && videoViewer) {
    // Entering fullscreen
    const container = videoViewer.closest('.inline-video-container');
    if (container) {
      lastFullscreenContainer = container;
      lastOriginalPosition = container.style.position;
      container.style.position = '';
    }
  } else if (!document.fullscreenElement && lastFullscreenContainer) {
    // Exiting fullscreen
    lastFullscreenContainer.style.position = lastOriginalPosition || '';
    lastFullscreenContainer = null;
    lastOriginalPosition = null;
  }
});
